export default {
  header: {
    title: 'Hienoa! Saat seuraavat ilmaiseksi tilauksesi mukana:',
    subtitle: 'Sovellamme alennuksen kassalla.',
  },
  footer: {
    buttons: {
      no_thanks: 'Ei kiitos',
      add_to_basket: 'Lisää koriin',
    },
  },
};
